import React, { useState, useEffect } from "react";
import { Switch, Route, useHistory, Router, Link, useParams } from "react-router-dom"
import SolutionsContent from "./SolutionsContent";
import AppCard from '../Applications/AppCard';
import axios from 'axios';
import config from '../../other/config';
const { serverAPI } = config;

export default function SolutionListRouter(props) {
	let { IsRu, selectedIndex, setAppBasket, basketChips, setIsRu, handleExpandClick } = props
	let { bank } = useParams();
	let history = useHistory();

	const [first, setFirts] = useState(true);
	const [bankinfo, setBankinfo] = useState([]);

	useEffect(() => {
		if (first) {
			//handleExpandClick(1) Tarasenko логика перенесена на LeftBar
			setFirts(false)
		}

		let didCancel = false;
		async function fetchData() {
			// setloading(true)
			const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/${props.selectedIndex}/${IsRu}`)
			//console.log(_bankinfo.data)
			if (!didCancel) {
				if (_bankinfo && _bankinfo.data) {
					// setloading(false)
					// setID(_bankinfo.data[0].ID)
					setBankinfo(_bankinfo.data[0])
					//console.log(_bankinfo.data)
				}
			}
		}

		fetchData();
		// return () => {
		//   didCancel = true;
		// }
	}, [bank]);

	return (
		<Switch>
			<Router history={history}>
				<Route exact path='/solutions/:bank/overview'>
					<SolutionsContent
						basketChips={basketChips}
						type={'solutions'}
						selectedIndex={selectedIndex}
						isAuth={props.isAuth}
						IsRu={IsRu}
						setErr={props.setErr}
						usname={props.usname}
						kloUser = {props.kloUser}
						_kloUser = {props._kloUser}
						getKloStatuses = {props.getKloStatuses}
						userCollection = {props.userCollection}
						saveCollection = {props.saveCollection}
					/>
				</Route>

				<Route exact path='/solutions/card/:code'>
					<AppCard
						isAuth={props.isAuth}
						usname={props.usname}
						IsRu={IsRu}
						setIsRu={setIsRu}
						basketChips={basketChips}
						setAppBasket={setAppBasket}
						kloUser = {props.kloUser}
						_kloUser = {props._kloUser}
						getKloStatuses = {props.getKloStatuses}
						userCollection = {props.userCollection}
						saveCollection = {props.saveCollection}
					/>
				</Route>

				{
					window.location.pathname.substr(0, 16) !== '/solutions/card/'
						?
						window.location.pathname.substr(-8) == 'overview'
							?
							null
							:
							props.setErr(true)
						:
						null
				}
			</Router>
		</Switch>
	)
}